import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RUI_FIELD_ERROR_ATTR } from "../form/control-protocol";
export function RuiFieldError({
  class: className,
  ...props
}) {
  return /* @__PURE__ */jsx("p", {
    ...props,
    ...{
      [RUI_FIELD_ERROR_ATTR]: ""
    },
    class: cx("rui-field__error", className),
    role: "alert",
    hidden: true
  });
}